export const environment = {
    appName: 'Sportilink',
    defaultSportType: '',
    serverUrl: 'https://api.sportilink.com',
    clientUrl: 'https://app.sportilink.com/#',
    websiteUrl: 'https://sportilink.com',
};
